<div class="amway-header-creator-modal-all">
  <div class="amway-header-modal amwayMenuLogin"
    [ngClass]="{'active' : open}"
    data-login="yes">
    <div class="bg-ahm"></div>
    <div class="ahm-content-right">
      <div class="ahm-on-scroll">
        <div class="ahm-close"
          (click)="closeUserModal()"></div>
        <div class="ah-container-signin">
          <div class="ah-title-signin">
            {{'HEADER.hello' | translate}}, {{fullName}}
          </div>
          <div class="ah-line"></div>

          <a class="ah-subtitle-signin "
            aria-label="sign out">
            <div class="ah-subtitle-signin-icon icon-signout"></div>
            <div class="ah-subtitle-signin-text"
              (click)="signOutUser()">{{'HEADER.sign_out'|translate}}</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
